var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoop = function SvgLoop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 64c0-12.15 9.85-22 22-22h80c12.15 0 22 9.85 22 22s-9.85 22-22 22H24C11.85 86 2 76.15 2 64m22-18c-9.941 0-18 8.059-18 18s8.059 18 18 18h80c9.941 0 18-8.059 18-18s-8.059-18-18-18z",
    clipRule: "evenodd"
  })));
};
export default SvgLoop;